import { createMemoryHistory, createWebHistory, createRouter as _createRouter } from 'vue-router'
import { STATIC_PAGES } from './config/static-pages.js'

// Lazy load pages
const Home = () => import('./pages/Home.vue')
const Products = () => import('./pages/Products.vue')
const ProductDetail = () => import('./pages/ProductDetail.vue')
const Cart = () => import('./pages/Cart.vue')
const Checkout = () => import('./pages/Checkout.vue')
const ThankYou = () => import('./pages/ThankYou.vue')
const TextPage = () => import('./pages/TextPage.vue')
const Brands = () => import('./pages/Brands.vue')
const BrandDetail = () => import('./pages/BrandDetail.vue')
const CategoryPage = () => import('./pages/CategoryPage.vue')
const CategoriesPage = () => import('./pages/Categories.vue')
const Wishlist = () => import('./pages/Wishlist.vue')
const FAQ = () => import('./pages/FAQ.vue')
const Klantenservice = () => import('./pages/Klantenservice.vue')
const HoeHetWerkt = () => import('./pages/HoeHetWerkt.vue')
const Account = () => import('./pages/Account.vue')
const FunnelLanding = () => import('./pages/FunnelLanding.vue')
const FunnelLead = () => import('./pages/FunnelLead.vue')
const FunnelBundel = () => import('./pages/FunnelBundel.vue')

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      title: 'Zonnepanelen & Laadpalen | Plug2Charge.nl',
      description: 'Koop voordelig zonnepanelen, laadpalen en complete sets. ✓ Gratis verzending vanaf €50 ✓ 2 jaar garantie ✓ Expert advies',
      keywords: 'zonnepanelen, balkonzonnepanelen, laadpalen, thuisladen, complete sets',
      ogType: 'website'
    }
  },
  {
    path: '/producten',
    name: 'products',
    component: Products,
    meta: {
      title: 'Alle Producten | Plug2Charge.nl',
      description: 'Ontdek ons complete assortiment zonnepanelen, laadpalen en accessoires. Beste kwaliteit tegen scherpe prijzen.',
      keywords: 'producten, webshop, zonnepanelen, laadpalen',
      fetchSEO: false // Static page
    }
  },
  {
    path: '/product/:slug',
    name: 'product-detail',
    component: ProductDetail,
    meta: {
      fetchSEO: true,
      seoType: 'product'
    }
  },
  {
    path: '/cart',
    name: 'cart',
    component: Cart,
    meta: {
      title: 'Winkelwagen | Plug2Charge.nl',
      description: 'Bekijk je winkelwagen en ga verder naar de kassa',
      robots: 'noindex, nofollow' // Don't index cart pages
    }
  },
   {
    path: '/wishlist',
    name: 'wishlist',
    component: Wishlist,
    meta: {
      title: 'Verlanglijst | Plug2Charge.nl',
      description: 'Bekijk je verlanglijst en ga verder naar de kassa',
      robots: 'noindex, nofollow'
    }
  },
  {
    path: '/account',
    name: 'account',
    component: Account,
    meta: {
      title: 'Mijn Account | Plug2Charge.nl',
      description: 'Log in of maak een account aan bij Plug2Charge',
      robots: 'noindex, nofollow'
    }
  },
  {
    path: '/account/bestellingen',
    name: 'account-orders',
    component: Account,
    meta: {
      title: 'Mijn Bestellingen | Plug2Charge.nl',
      description: 'Bekijk je bestellingen bij Plug2Charge',
      robots: 'noindex, nofollow'
    }
  },
  {
    path: '/checkout',
    name: 'checkout',
    component: Checkout,
    meta: {
      title: 'Afrekenen | Plug2Charge.nl',
      description: 'Veilig afrekenen bij Plug2Charge',
      robots: 'noindex, nofollow'
    }
  },
  {
    path: '/thank-you',
    name: 'thank-you',
    component: ThankYou,
    meta: {
      title: 'Bedankt voor je bestelling | Plug2Charge.nl',
      description: 'Je bestelling is succesvol geplaatst',
      robots: 'noindex, nofollow'
    }
  },
  {
    // Landingspagina na Mollie-redirect (betaald én geannuleerd). De WP-plugin
    // moet z'n Mollie redirectUrl hierheen laten wijzen: /betaling-status?key=<order_key>
    path: '/betaling-status',
    name: 'betaling-status',
    component: () => import('./pages/Betaalstatus.vue'),
    meta: {
      title: 'Betaalstatus | Plug2Charge.nl',
      description: 'De status van je betaling',
      robots: 'noindex, nofollow'
    }
  },
  {
    path: '/page/:slug',
    name: 'text-page',
    component: TextPage,
    meta: { fetchSEO: true, seoType: 'page' }
  },

  // ── WordPress-pagina's (content beheerd vanuit WP-dashboard) ─────────────────
  {
    path: '/hoe-het-werkt',
    name: 'hoe-het-werkt',
    component: HoeHetWerkt,
    meta: {
      title: 'Hoe het werkt | Plug2Charge.nl',
      description: 'In 4 eenvoudige stappen naar energieonafhankelijkheid. Ontdek hoe je zonnepanelen, laadpalen en thuisbatterijen bestelt, installeert en begint te besparen.',
      fetchSEO: false,
    }
  },
  { path: '/garantie',           name: 'garantie',           component: TextPage, meta: { wpSlug: 'garantie',           title: 'Garantie & Service | Plug2Charge.nl', description: 'Alles over garantie en service bij Plug2Charge: garantietermijnen, hoe je een beroep doet op je garantie en onze after-sales ondersteuning.' } },
  { path: '/algemene-voorwaarden', name: 'algemene-voorwaarden', component: TextPage, meta: { wpSlug: 'algemene-voorwaarden', title: 'Algemene Voorwaarden | Plug2Charge.nl', description: 'De algemene voorwaarden van Plug2Charge: bestellen, betalen, leveren, retourneren en garantie. Lees hier je rechten en plichten.' } },
  { path: '/advies',             name: 'advies',             component: TextPage, meta: { wpSlug: 'advies',             title: 'Gratis Advies | Plug2Charge.nl', description: 'Gratis en vrijblijvend advies over zonnepanelen, laadpalen en thuisbatterijen. Onze specialisten helpen je de juiste keuze te maken.' } },
  { path: '/subsidies',          name: 'subsidies',          component: TextPage, meta: { wpSlug: 'subsidies',          title: 'Subsidies & Regelingen | Plug2Charge.nl', description: 'Overzicht van actuele subsidies en regelingen voor zonnepanelen, thuisbatterijen en laadpalen. Bespaar op je verduurzaming.' } },
  { path: '/klantenservice',     name: 'klantenservice',     component: Klantenservice, meta: { title: 'Klantenservice | Plug2Charge.nl', description: 'Neem contact op met de klantenservice van Plug2Charge. Bereikbaar via mail of live chat.' } },
  {
    path: '/veelgestelde-vragen',
    name: 'veelgestelde-vragen',
    component: FAQ,
    meta: {
      title: 'Veelgestelde Vragen | Plug2Charge.nl',
      description: 'Antwoorden op de meest gestelde vragen over zonnepanelen, laadpalen, levering en garantie bij Plug2Charge.',
      keywords: 'faq, veelgestelde vragen, zonnepanelen, laadpalen, garantie, levering',
      fetchSEO: false,
    }
  },
  { path: '/diensten',           name: 'diensten',           component: TextPage, meta: { wpSlug: 'diensten',           title: 'Diensten | Plug2Charge.nl', description: 'De diensten van Plug2Charge: van advies en levering tot installatie van zonnepanelen, laadpalen en thuisbatterijen.' } },
  { path: '/diensten/installatie', redirect: '/installatie' }, // → bestaande Vue-pagina
  {
    path: '/merken',
    name: 'brands',
    component: Brands,
    meta: {
      title: 'Premium Merken | Plug2Charge.nl',
      description: 'Ontdek onze selectie van premium A-merken. ✓ Officiële dealer ✓ Beste kwaliteit ✓ Fabrieksgarantie',
      keywords: 'merken, LONGi, Trina, JA Solar, Enphase, Hoymiles',
      fetchSEO: false
    }
  },
  {
    path: '/merk/:brand',
    name: 'brand',
    component: BrandDetail,
    meta: {
      fetchSEO: true,
      seoType: 'brand'
    }
  },
  {
    path: '/merk/:brand/:category',
    name: 'brand-category',
    component: BrandDetail,
    meta: {
      fetchSEO: true,
      seoType: 'brand-category'
    }
  },
  {
    path: '/categorieen',
    name: 'categories',
    component: CategoriesPage,
    meta: {
      title: 'Shop op Categorie | Plug2Charge.nl',
      description: 'Bekijk al onze productcategorieën. Van zonnepanelen tot laadpalen, wij hebben het allemaal.',
      keywords: 'categorieën, productcategorieën, shop',
      fetchSEO: false
    }
  },
  {
    path: '/categorie/:category',
    name: 'category',
    component: CategoryPage,
    meta: {
      fetchSEO: true,
      seoType: 'category'
    }
  },
  
  // ── Statische pagina's (uit src/config/static-pages.js) ─────────────────────
  ...STATIC_PAGES.map(p => ({
    path:      p.path,
    name:      p.name,
    component: p.component,
    meta: {
      title:       p.title,
      description: p.description,
      keywords:    p.keywords,
      fetchSEO:    false,
    },
  })),

  // ── Redirects: kale/oude URL's die anders op 404 vallen ──────────────────────
  // Externe links (oude SEO-index / Google Ads) wezen naar kale categorie-slugs.
  { path: '/thuisbatterijen', redirect: '/categorie/thuisbatterijen' },

  // ── Acties / aanbiedingen ───────────────────────────────────────────────────
  // /acties = eigen deals-pagina (afgeprijsde producten). /acties/<slug> mapt
  // 1-op-1 op een bestaande categorie (bijv. /acties/zonnepanelen-sets →
  // /categorie/zonnepanelen-sets), zodat de mega-menu-links blijven werken.
  {
    path: '/acties',
    name: 'acties',
    component: () => import('./pages/Acties.vue'),
    meta: {
      title: 'Acties & Aanbiedingen | Plug2Charge.nl',
      description: 'Tijdelijk extra voordeel op zonnepanelen, laadpalen en thuisbatterijen. Bekijk al onze actuele aanbiedingen en kortingen.',
      keywords: 'acties, aanbiedingen, korting, deals, zonnepanelen, laadpalen, thuisbatterij',
      fetchSEO: false,
    },
  },
  { path: '/acties/:slug', redirect: to => ({ path: `/categorie/${to.params.slug}` }) },

  // ── Funnels / campagnepagina's ──────────────────────────────────────────────
  {
    path: '/gratis-energieadvies',
    name: 'gratis-energieadvies',
    component: FunnelLead,
    meta: {
      title: 'Gratis Energieadvies | Plug2Charge.nl',
      description: 'Vraag gratis en vrijblijvend energieadvies aan. Onze specialisten rekenen uit welke balkon zonnepanelen of thuisbatterij het beste bij jou passen.',
      keywords: 'gratis energieadvies, zonnepanelen advies, thuisbatterij advies',
      fetchSEO: false,
    },
  },
  {
    path: '/actie/:slug',
    name: 'funnel-landing',
    component: FunnelLanding,
    meta: {
      title: 'Actie | Plug2Charge.nl',
      description: 'Ontdek onze actuele aanbieding en bespaar op je energierekening.',
      fetchSEO: false,
    },
  },
  {
    path: '/bundel/:slug',
    name: 'funnel-bundel',
    component: FunnelBundel,
    meta: {
      title: 'Complete Bundel | Plug2Charge.nl',
      description: 'Stel je complete bundel samen en profiteer van voordeel. Alles in één bestelling, samen bezorgd.',
      fetchSEO: false,
    },
  },

  // ── Keuzehulp (product-finder funnel) ───────────────────────────────────────
  {
    path: '/keuzehulp',
    name: 'keuzehulp-hub',
    component: () => import('./pages/KeuzehulpHub.vue'),
    meta: {
      title: 'Keuzehulp - vind het juiste product | Plug2Charge.nl',
      description: 'Weet je niet zeker wat je nodig hebt? Doe de keuzehulp en vind in een paar korte vragen de zonnepanelen, laadpaal of thuisbatterij die bij jou past.',
      fetchSEO: false,
    },
  },
  {
    path: '/keuzehulp/:topic',
    name: 'keuzehulp',
    component: () => import('./pages/Keuzehulp.vue'),
    meta: {
      title: 'Keuzehulp | Plug2Charge.nl',
      description: 'Beantwoord een paar korte vragen en ontdek welk product het beste bij jouw situatie past.',
      fetchSEO: false,
    },
  },

  {
    path: '/nieuwsbrief-afmelden',
    name: 'nieuwsbrief-afmelden',
    component: () => import('./pages/NieuwsbriefAfmelden.vue'),
    meta: {
      title: 'Nieuwsbrief afmelden | Plug2Charge.nl',
      description: 'Meld je af voor de nieuwsbrief van Plug2Charge.',
      robots: 'noindex, nofollow',
    },
  },

  // 404 Not Found (add at the end)
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('./pages/NotFound.vue'),
    meta: {
      title: 'Pagina niet gevonden | Plug2Charge.nl',
      description: 'De pagina die je zoekt bestaat niet',
      robots: 'noindex, nofollow'
    }
  }
]

// SEO Helper Functions
async function fetchProductSEO(slug) {
  try {
    const response = await fetch(`/_wc/v3/products?slug=${slug}`)
    
    if (!response.ok) return null
    
    const products = await response.json()
    if (products.length === 0) return null
    
    const product = products[0]
    
    return {
      title: `${product.name} | Plug2Charge.nl`,
      description: product.short_description 
        ? stripHtml(product.short_description).substring(0, 160)
        : `Koop ${product.name} bij Plug2Charge. ${product.on_sale ? 'Nu in de aanbieding!' : ''} ✓ Gratis verzending ✓ 2 jaar garantie`,
      keywords: [
        product.name,
        ...product.categories.map(cat => cat.name),
        ...product.tags.map(tag => tag.name)
      ].join(', '),
      ogType: 'product',
      ogImage: product.images?.[0]?.src || null,
      ogPrice: product.price,
      ogCurrency: 'EUR',
      canonical: `https://plug2charge.nl/product/${slug}`
    }
  } catch (error) {
    console.error('Error fetching product SEO:', error)
    return null
  }
}

async function fetchCategorySEO(slug) {
  try {
    const response = await fetch(`/_wc/v3/products/categories?slug=${slug}`)
    
    if (!response.ok) return null
    
    const categories = await response.json()
    if (categories.length === 0) return null
    
    const category = categories[0]
    
    return {
      title: `${category.name} | Plug2Charge.nl`,
      description: category.description
        ? stripHtml(category.description).substring(0, 160)
        : `Ontdek ons assortiment ${category.name}. ✓ Beste kwaliteit ✓ Scherpe prijzen ✓ Gratis verzending vanaf €50`,
      keywords: `${category.name}, kopen, webshop, plug2charge`,
      ogType: 'website',
      ogImage: category.image?.src || null,
      canonical: `https://plug2charge.nl/categorie/${slug}`
    }
  } catch (error) {
    console.error('Error fetching category SEO:', error)
    return null
  }
}

async function fetchBrandSEO(slug, categorySlug = null) {
  try {
    // Gebruik /api/brands - lost pa_merk slug correct op naar numeriek ID
    const response = await fetch('/_brands')
    if (!response.ok) return null

    const brands = await response.json()
    const brand  = brands.find(b => b.slug === slug)
    if (!brand) return null

    let title       = `${brand.name} Producten | Plug2Charge.nl`
    let description = `Ontdek het volledige ${brand.name} assortiment bij Plug2Charge. ✓ Officiële dealer ✓ Beste prijzen ✓ Snelle levering`

    if (categorySlug) {
      const catRes = await fetch(`/_wc/v3/products/categories?slug=${categorySlug}`)
      if (catRes.ok) {
        const cats = await catRes.json()
        if (cats.length > 0) {
          title       = `${brand.name} ${cats[0].name} | Plug2Charge.nl`
          description = `Bekijk ons assortiment ${brand.name} ${cats[0].name}. ✓ Officiële dealer ✓ Beste prijzen ✓ Snelle levering`
        }
      }
    }

    return {
      title,
      description,
      keywords:  `${brand.name}, producten, kopen, webshop${categorySlug ? `, ${categorySlug}` : ''}`,
      ogType:    'website',
      ogImage:   brand.image?.src || null,
      canonical: `https://plug2charge.nl/merk/${slug}${categorySlug ? `/${categorySlug}` : ''}`
    }
  } catch (error) {
    console.error('Error fetching brand SEO:', error)
    return null
  }
}

async function fetchPageSEO(slug) {
  try {
    const response = await fetch(`/api/wp/v2/pages?slug=${slug}`)
    
    if (!response.ok) return null
    
    const pages = await response.json()
    if (pages.length === 0) return null
    
    const page = pages[0]
    
    return {
      title: `${page.title.rendered} | Plug2Charge.nl`,
      description: page.excerpt?.rendered
        ? stripHtml(page.excerpt.rendered).substring(0, 160)
        : stripHtml(page.content.rendered).substring(0, 160),
      ogType: 'article',
      canonical: `https://plug2charge.nl/page/${slug}`
    }
  } catch (error) {
    console.error('Error fetching page SEO:', error)
    return null
  }
}

// Helper to strip HTML tags
function stripHtml(html) {
  if (!html) return ''
  return html.replace(/<[^>]*>/g, '').trim()
}

// Update meta tags
function updateMetaTags(seoData) {
  if (!seoData) return
  
  // Update title
  if (seoData.title) {
    document.title = seoData.title
  }
  
  // Update or create meta tags
  const metaTags = [
    { name: 'description', content: seoData.description },
    { name: 'keywords', content: seoData.keywords },
    { name: 'robots', content: seoData.robots || 'index, follow' },
    { property: 'og:title', content: seoData.title },
    { property: 'og:description', content: seoData.description },
    { property: 'og:type', content: seoData.ogType || 'website' },
    { property: 'og:url', content: seoData.canonical || window.location.href },
    { property: 'og:site_name', content: 'Plug2Charge.nl' },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: seoData.title },
    { name: 'twitter:description', content: seoData.description }
  ]
  
  // Add Open Graph image if available
  if (seoData.ogImage) {
    metaTags.push({ property: 'og:image', content: seoData.ogImage })
    metaTags.push({ name: 'twitter:image', content: seoData.ogImage })
  }
  
  // Add product-specific OG tags
  if (seoData.ogType === 'product' && seoData.ogPrice) {
    metaTags.push({ property: 'product:price:amount', content: seoData.ogPrice })
    metaTags.push({ property: 'product:price:currency', content: seoData.ogCurrency || 'EUR' })
  }
  
  // Update each meta tag
  metaTags.forEach(({ name, property, content }) => {
    if (!content) return
    
    const selector = name ? `meta[name="${name}"]` : `meta[property="${property}"]`
    let element = document.querySelector(selector)
    
    if (!element) {
      element = document.createElement('meta')
      if (name) element.setAttribute('name', name)
      if (property) element.setAttribute('property', property)
      document.head.appendChild(element)
    }
    
    element.setAttribute('content', content)
  })
  
  // Update canonical link
  if (seoData.canonical) {
    let canonical = document.querySelector('link[rel="canonical"]')
    if (!canonical) {
      canonical = document.createElement('link')
      canonical.setAttribute('rel', 'canonical')
      document.head.appendChild(canonical)
    }
    canonical.setAttribute('href', seoData.canonical)
  }
}

export function createRouter() {
  const router = _createRouter({
    history: import.meta.env.SSR 
      ? createMemoryHistory('/') 
      : createWebHistory('/'),
    routes,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      } else {
        return { top: 0 }
      }
    }
  })
  
  // SPA page_view tracking - stuur bij elke navigatie een GA4 event
  router.afterEach((to) => {
    if (import.meta.env.SSR || typeof window === 'undefined') return
    // Kleine vertraging zodat document.title al bijgewerkt is
    setTimeout(() => {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'page_view', {
          page_path:  to.fullPath,
          page_title: document.title,
        })
      }
    }, 100)
  })

  // Global navigation guard voor SEO
  // BELANGRIJK: next() wordt DIRECT aangeroepen zodat navigatie nooit wacht
  // op een API-call. SEO meta-tags worden daarna asynchroon bijgewerkt.
  router.beforeEach((to, from, next) => {
    // Statische routes: zet meta direct (geen fetch nodig)
    if (!to.meta.fetchSEO) {
      to.meta.seoData = {
        title:       to.meta.title,
        description: to.meta.description,
        keywords:    to.meta.keywords,
        robots:      to.meta.robots,
        ogType:      to.meta.ogType,
      }
      if (!import.meta.env.SSR) updateMetaTags(to.meta.seoData)
    }

    // Navigeer DIRECT - geen await, geen blokkering
    next()

    // Dynamische SEO op de achtergrond ophalen (niet-blokkerend)
    if (to.meta.fetchSEO && !import.meta.env.SSR) {
      ;(async () => {
        try {
          let seoData = null
          switch (to.meta.seoType) {
            case 'product':      seoData = await fetchProductSEO(to.params.slug);                          break
            case 'category':     seoData = await fetchCategorySEO(to.params.category);                    break
            case 'brand':        seoData = await fetchBrandSEO(to.params.brand);                          break
            case 'brand-category': seoData = await fetchBrandSEO(to.params.brand, to.params.category);   break
            case 'page':         seoData = await fetchPageSEO(to.params.slug);                            break
          }
          if (seoData) {
            to.meta.seoData = seoData
            updateMetaTags(seoData)
          }
        } catch (e) {
          // SEO-fouten mogen navigatie nooit breken
        }
      })()
    }
  })
  
  return router
}